<script lang="ts">
    import { Link, useNavigate } from "svelte-navigator";
    import { appManager } from "../../AppManagerStore";
  
    export let name = "";
  </script>
  
  <header class="bg-dark pt-9 pb-11 d-none d-md-block">
    <div class="container-md">
      <div class="row align-items-center">
        <div class="col">
          <h1 class="fw-bold text-white mb-2">Organization Settings</h1>
  
          <p class="fs-lg text-white-75 mb-0">
            Settings for <a class="text-reset" href="mailto:{name}">{name}</a>
          </p>
        </div>
      </div>
    </div>
  </header>
  